export default [
  {
  path: '/ExhibitorSearch',//展商信息-搜索页面  历届参展商
  name: 'SearchPage',
  meta: {
    title: '搜索页面_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/ExhibitorSearch.vue')
},
// {
//   path: '/ExhibitorSearchList',//展商信息-搜索页面列表  历届参展商
//   name: 'SearchListPage',
//   component: () => import('@/view/ExhibitorSpa/ExhibitorSearchList.vue')
// },
{
  path: '/ExhibitorSearchDet',//展商信息-搜索页面详情  历届参展商详情
  name: 'SearchDetEPage',
  meta: {
    title: '搜索页面列表 _参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/ExhibitorSearchDet.vue'),
},{
  path: '/ExhibitorObj',//参展对象及资质
  name: 'ojbPage',
   meta: {
    title: '参展对象及资质_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/object.vue')
},{
  path: '/ExhibitorPic',//参会客商情况
  name: 'picPage',
   meta: {
    title: '参会客商情况_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/pic.vue')
},{
  path: '/Exhibitorpdf',//主宾国活动简介  主宾省活动简介 参展指南下载  参展邀请函
  name: 'pdfPage',
   meta: {
    title: '/主宾国活动简介_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/pdf.vue')
},{
  path: '/ExhibitorContact',//联络展务组  联络主场服务商
  name: 'contactEPage',
   meta: {
    title: '联络展务组_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/contact.vue')
},{
  path: '/ExhibitorPaperwork',//证件办理
  name: 'paperworkPage',
   meta: {
    title: '证件办理_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/paperwork.vue')
},{
  path: '/ExhibitorManage',//展馆管理规定
  name: 'manageEPage',
   meta: {
    title: '展馆管理规定_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/manage.vue')
},{
  path: '/ExhibitorSafety',//消防安全规定
  name: 'safetyEPage',
   meta: {
    title: '消防安全规定_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/safety.vue')
},{
  path: '/ExhibitorTransport',//展品运输指南
  name: 'transportEPage',
   meta: {
    title: '展品运输指南_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/transport.vue')
},{
  path: '/ExhibitorClearance',//境外展品通关
  name: 'clearanceEPage',
   meta: {
    title: '境外展品通关_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/clearance.vue')
},{
  path: '/ExhibitorLayout',//布、撤展规定
  name: 'layoutEPage',
   meta: {
    title: '布展规定_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/layout.vue')
},
{
  path: '/ExhibitorService',//展馆服务
  name: 'serviceEPage',
   meta: {
    title: '展馆服务_参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/service.vue')
},
{
  path: '/ExhibitorFileData',//展馆服务
  name: 'ExhibitorFileData',
   meta: {
    title: '参展指南_中国国际投资贸易洽谈会'
  },
  component: () => import('@/view/ExhibitorSpa/FileData.vue')
},
]




// WEBPACK FOOTER //
// ./src/router/ExhibitorSpa.js